export const calcPercentage = (input, percentage) => {
  return (input / 100) * percentage;
}
